import {get_token} from "@/router";

export default {
    data() {
        return ({
          token_exists: false,
          user_details: {
            "user_role": '',
            "user_id": '',
          },
          isSubmitting: false,
          topics:[],
          created_by_id:this.created_by,
          portals:[],
          isMaster: false,
          categories: [],
          selectedPortalId: null,
          selectedTopicId: null,
          searchQuery:"",
          topic_id: null,
          editingTopic: null,
          topic_name: '',
          isEditing: false,
          errors: {
            voice_description:null,
            voice_name:null,
            portal: null,
            segment: null,
            report_description: null
          },
          users:[],
          portal_types:[],
          selectedPortalType:null,
          payload:{},
          reviewers: [],
          event_types:[],
          event_type: '',
        });
      },
    methods:{
        getToken() {
            return get_token();
        },
        validationSegmentForm() {
            this.errors = {};
            let valid = true;

            if (!this.topic_name) {
                this.errors.topic_name = 'Segment name is required';
                valid = false;
            }

            if (!this.selectedPortalId) {
                this.errors.portal = "You must tag a portal.";
            }

            return valid;
            },
        createSegment() {
            if(!this.validationSegmentForm()) {
              return;
            }
             $('#segment_modal').modal('hide')

            this.isSubmitting = true;

            const requestData = {
                topic_name: this.topic_name,
                portal_id: this.$route.params.portal_id
              };

            $.ajax({
              type: "POST",
              url: `${process.env.VUE_APP_BACKEND_API_URL}/portal_management/create_topic_api/`,
              contentType: "application/json",
              headers: {
                'Authorization': `Token ${this.getToken()}`,
                'Content-Type': 'application/json'
              },
              data: JSON.stringify(requestData),
              success: (response) => {
                this.$emit('newSegment',response.topic)

                const status = response.status;
                if (status === "success") {

                  this.topics.push(response.topic);

                  this.topic_name = '';
                  this.errors.topic_name = '';
                }
              },
              error: (response) => {
                const response_data = response.responseJSON;
                if(response_data.status=="error"){
                 this.errors.topic_name=response_data.message
                }
            },
              complete: () => {
                this.isSubmitting = false;
              }
            });
          },
          updateSegment() {
            if (!this.validationSegmentForm()) {
              return;
            }

            // keep the edit modal open while the request is in-flight so
            // any server validation errors can be shown to the user
            this.isSubmitting = true;

            const requestData = {
              topic_id: this.editingTopic.id,
              topic_name: this.topic_name,
              portal_id: this.$route.params.portal_id,
            };

            $.ajax({
              type: 'POST',
              url: `${process.env.VUE_APP_BACKEND_API_URL}/portal_management/update_topic_api/`,
              contentType: "application/json",
              headers: {
                'Authorization': `Token ${this.getToken()}`,
                'Content-Type': 'application/json'
              },
              data: JSON.stringify(requestData),
              success: (response) => {
                if (response.status === "success") {
                  // hide modal only on success so errors (if any) remain visible
                  $('#edit_segment_modal').modal('hide');
                  this.$emit('editSegment', response.topic);
                  this.resetForm();
                }
              },
              error: (response) => {
                // try to extract a helpful message and show it on the form
                const response_data = response.responseJSON;
                if (response_data && response_data.status == "error") {
                  this.errors.topic_name = response_data.message;
                }
              },
              complete: () => {
                this.isSubmitting = false;
              }
            });
          },
            resetForm() {
              this.topic_name = '';
              this.errors = {};
              this.isEditing = false;
              this.editingTopic = null;
            },
            openEditModal(topic) {
              this.editingTopic = topic;
              this.topic_name = topic.name;
              this.isEditing = true;
            },
          },
        }